<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>即将过期</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div style="margin-top:30px">
                <ExTable
                    :isIndex="false"
                    :table-list="tableData"
                    :header="header"
                    height="300"
                    :total="total"
                    :activeIndex="searchParam.page"
                    @clickPage="clickPage"
                    @clickSize="clickSize"
                />
            </div>
        </div>
  </el-row>    
</template>

<script>
import ExTable from "@com/ExTable";
import {expireData} from "@http/overview/index";
import {formatDate,filterParams,sourceType} from "@/utils/filter";
export default {
    data() {
        return {
            tableData:[],
            searchParam: {
                page: 1,
                size: 10,
                expiredAt:new Date().getTime()
            },
            header: [
                { prop: "id", label: "订单号" },
                {
                    prop: "paymentAt",
                    label: "购买时间",
                    formatter: (row) => {
                        return formatDate(row.createdAt);
                    },
                },
                {
                    prop: "tsCount",
                    label: "时间戳总数",
                    formatter: (row) => {
                        return row.tsCount + "个";
                    },
                },
                {
                    prop: "suiteValidityPeriod",
                    label: "有效期",
                    formatter: (row) => {
                        if(row.suiteValidityPeriod==0){
                            return '永久有效'
                        }else{
                            return row.suiteValidityPeriod+'天'
                        }
                    },
                },
                {
                    prop: "remainTsCount",
                    label: "即将过期时间戳数",
                    formatter: (row) => {
                        return row.remainTsCount + "个";
                    },
                },
                {
                    prop: "status",
                    label: "状态",
                    formatter: (row) => {
                        if(row.status==1){
                            return '正在消费'
                        }else{
                            return '正在消费'
                        }
                    },
                },
                {
                    prop: "startAt",
                    label: "生效时间",
                    formatter: (row) => {
                        if(row.startAt){
                            return formatDate(row.startAt);
                        }else{
                            return '--'
                        }
                        
                    },
                },
                {
                    prop: "expiredAt",
                    label: "过期时间",
                    formatter: (row) => {
                        if(row.expiredAt){
                            return formatDate(row.expiredAt);
                        }else{
                            return '--'
                        }
                        
                    },
                },
            ],
            total:10,
        };
    },

    components: {ExTable},

    computed: {},

    created() {
        this.getTableData(filterParams(this.searchParam));
    },

    mounted() {},

    methods: {
        async getTableData(data) {
            let res = await expireData(data);
            this.tableData =res.data;
        },
        async clickPage(page) {
                this.searchParam.page = page;
                let res = await this.getTableData(filterParams(this.searchParam));
                this.tableData = res.data;
                this.total = res.total;
        },
        async clickSize(size) {
                this.searchParam.page = 1;
                this.searchParam.size = size;
                let res = await this.getTableData(filterParams(this.searchParam));
                this.tableData = res.data;
                this.total = res.total;
        },
    },
};
</script>
<style lang='scss' scoped>
</style>